<template>
	<div>
		<app-card>
			<v-card-title>
				<h3>Import Init Data</h3>
			</v-card-title>
			<v-layout row wrap justify-center>
				<v-flex xs12 md5>
					<v-menu
						:close-on-content-click="false"
						v-model="menu_month_picker"
						:nudge-right="40"
						lazy
						transition="scale-transition"
						offset-y
						full-width
						min-width="290px"
					>
						<v-text-field
							slot="activator"
							v-model="chosen_month"
							label="Chọn tháng"
							prepend-icon="event"
							single-line
							readonly
						></v-text-field>
						<v-date-picker
							min="2019-10"
							locale="vi-VI"
							type="month"
							v-model="chosen_month"
							@input="menu_month_picker = false"
						></v-date-picker>
					</v-menu>
				</v-flex>
				<v-flex xs12 md5>
					<v-btn
						@click="$refs.inputUpload.click()"
						color="primary"
					>
						Import File
					</v-btn>
					<input
						v-show="false"
						ref="inputUpload"
						type="file"
						@change="onFileSelected"
					/>
				</v-flex>
			</v-layout>
		</app-card>
	</div>
</template>
<script>
import api from "Api";
import XLSX from "xlsx";
import { getJsDateFromExcel } from 'Helpers';

export default {
	name: "init-data",
	data() {
		return {
			input_excel: [],
			menu_month_picker: false,
			chosen_month: new Date().toISOString().substring(0, 7),
			list_date_key: [
				"date_schedule_in", "date_in", "washing_machine_start",
				"internet_start", "internet_end", "date1_in", "date1_out",
				"motorbike1_start", "motorbike1_end", "date2_in", "date2_out",
				"motorbike2_start", "motorbike2_end", "date3_in", "date3_out",
				"motorbike3_start", "motorbike3_end", "date4_in", "date4_out",
				"motorbike4_start", "motorbike4_end", "date5_in", "date5_out",
				"motorbike5_start", "motorbike5_end", "date6_in", "date6_out",
				"motorbike6_start", "motorbike6_end"
			]
		};
	},
	methods: {
		onFileSelected: function(e) {
			let files = e.target.files,
				f = files[0];
			let reader = new FileReader();
			let that = this;
			reader.onload = function(e) {
				that.loader = true;
				let data = new Uint8Array(e.target.result);
				let arr = new Array();
				for (let i = 0; i != data.length; ++i)
					arr[i] = String.fromCharCode(data[i]);
				let bstr = arr.join("");

				/* Call XLSX */
				let workbook = XLSX.read(bstr, {
					type: "binary"
				});
				let first_sheet_name = workbook.SheetNames[0];
				let worksheet = workbook.Sheets[first_sheet_name];
				that.input_excel = XLSX.utils.sheet_to_json(worksheet, {
					raw: true
				});
				that.submitInitData();
			};
			reader.readAsArrayBuffer(f);
		},
		formatInitData: function (data){
			for (const key in data) {
				if (data.hasOwnProperty(key)) {
					let element = data[key];
					if ( typeof element == 'string' && element.trim() == "chưa ở") {
						data[key] = ''
					}
					if (this.list_date_key.includes(key)){
						data[key] = data[key] ? getJsDateFromExcel(data[key]) : ''
					}
				}
			}
			return data
		},
		submitInitData: async function() {
			this.input_excel = this.input_excel.map(data => this.formatInitData(data))

			const list_data = this.input_excel.filter(data => data.building !== "deposit" && data.building !== "checkout");
			const list_checkout = this.input_excel.filter(data => data.building === "checkout");
			const list_deposit = this.input_excel.filter(data => data.building === "deposit");

			this.$store.commit("loading", true);
			const data_init = await api.request_api("/general/import-intial-data", {
				month: this.chosen_month,
				list_data
			});
			const promise_checkout = list_checkout.map(data => api.createCheckOut(JSON.parse(data.room_price)))
			const data_checkout = await Promise.all(promise_checkout);
			const promise_deposit = list_deposit.map(data => api.createDepositReceipt(JSON.parse(data.room_price)))
			const data_deposit = await Promise.all(promise_deposit);
			this.$store.commit("loading", false);
			// if (data.status === 200) {
			// 	swal.fire('Thành công', data.data.message, 'success')
			// 	this.$store.dispatch("getAppData");
			// }			
			// else swal.fire('Lỗi', data.message, 'error')
			swal.fire('Xong!', "Đã chạy xong hết các promise, ko biết success bao nhiêu cả :v", 'success')
		}
	}
};
</script>